// extracted by mini-css-extract-plugin
export var banner = "_t1-0";
export var settingRow = "_t1-2";
export var titleIcon = "_t1-1";